import React, { useEffect, useState } from "react";
import MetricsSection from "./MetricsSection";
import GraphicsSection from "./GraphicsSection";
import { Container } from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_PROFILE } from "../../../../services/graphql/queries/user/profileQuery";
import { useDispatch, useSelector } from "react-redux";
import { setBodyData, setPreferences } from "../../../../redux/slice/userSlice";
import { sportsPerformance } from "../../../../redux/slice/routeSlice";
import Loading from "../../../../components/Loading/Loading";
import ModalAlert from "../../../../components/ModalAlert/ModalAlert";
import ModalAlertStatusMembership from "../../../../components/ModalAlertStatusMembership/ModalAlertStatusMembership.";
import { getMembershipByUser } from "../../../../services/rest/membership/membershipService";
import { setMembership } from "../../../../redux/slice/membershipSlice";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import { getMembershipStatus } from "../../../../hooks/useMembershipExpiration";
import { getHistoryBadgesAPI } from "../../../../services/rest/badges/badgesService";
import { clearBadge, setBadge } from "../../../../redux/slice/badgeSlice";

const HistoryActivity = () => {
  const { _id } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const dispatch = useDispatch();
  const nowDate = new Date();
  const auxDate = nowDate.toISOString();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const { loading: gqlLoading, data } = useQuery(GET_PROFILE, {
    variables: { userId: _id },
    skip: !_id,
  });
  const getCurrentMembership = async () => {
    try {
      const currentMembership = await getMembershipByUser({ userId: _id });
      let status = { isExpired: true };

      if (
        currentMembership?.activeMemb?.membershipType &&
        currentMembership?.activeMemb?.membershipType !== "Free"
      ) {
        status = getMembershipStatus(
          currentMembership?.activeMemb?.expiresAt ?? auxDate
        );
      }

      dispatch(
        setMembership({
          _id: currentMembership?.activeMemb?._id ?? 0,
          planName: currentMembership?.activeMemb?.membershipType ?? "Free",
          price: currentMembership?.activeMemb?.amount ?? 0,
          currency: currentMembership?.activeMemb?.currency ?? "MXN",
          description: currentMembership?.description ?? [],
          routeLimit: currentMembership?.routeLimit ?? 0,
          membershipStatus: status?.isExpired ? "inactive" : "active",
          lastPayment: currentMembership?.activeMemb?.paymentDate ?? auxDate,
          nextPayment: currentMembership?.activeMemb?.expiresAt ?? auxDate,
        })
      );
      const historyBadges = await getHistoryBadgesAPI(_id);

      if (historyBadges?.length > 0) {
        const lastBadge = historyBadges[historyBadges.length - 1];
        dispatch(
          setBadge({
            _id: lastBadge?.badgeId ?? 0,
            nameBadge: lastBadge?.badgeName ?? "Explorador Inicial",
            description: "",
            iconURL: "",
            type: "",
            goalValue: "",
            membreshipReq: "",
          })
        );
      } else {
        dispatch(clearBadge());
      }
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      // console.log("Error", error);
      toast.error(
        `En este momento no se pudo obtener su información.\n ${message}`
      );
    }
  };
  useEffect(() => {
    if (!_id) {
      // console.log("No hay _id", _id);
      setLoading(false);

      return;
    }

    // Ejecutar ambas peticiones y esperar a que terminen
    const fetchAllData = async () => {
      setLoading(true);
      await Promise.all([
        !gqlLoading
          ? Promise.resolve()
          : new Promise((resolve) => {
              const interval = setInterval(() => {
                if (!gqlLoading) {
                  clearInterval(interval);
                  resolve();
                }
              }, 100);
            }),
        getCurrentMembership(),
      ]);
      setLoading(false);
    };

    fetchAllData();
  }, [_id, gqlLoading]);
  useEffect(() => {
    if (data) {
      if (membershipStatus !== "active") {
        setOpen(true);
      }
      const profile = data.getRunnerProfile;
      if (!profile) {
        return;
      }
      console.log("Perfil del usuario:", profile);

      dispatch(
        setBodyData({
          weight: profile?.answers?.general?.peso ?? 0,
          height: profile?.answers?.general?.altura ?? 0,
        })
      );

      dispatch(
        setPreferences({
          horario: profile?.answers?.preferencias?.horario ?? "Matutino",
          terreno: profile?.answers?.preferencias?.terreno ?? "Pista",
          distancia: profile?.answers?.preferencias?.distancia ?? "2-5 km",
        })
      );
      dispatch(
        sportsPerformance({
          kmCompleted: profile?.totalKm ?? 0,
          routesCompleted: profile?.rutasCompletas ?? 0,
        })
      );
    }
  }, [data, dispatch]);

  return (
    <Container
      style={{
        maxWidth: "100%",
        gap: 20,
        padding: 20,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Loading loading={loading} />
      <ModalAlert open={open} setOpen={setOpen} />
      {!loading && <ModalAlertStatusMembership />}
      <MetricsSection />
      <GraphicsSection />
    </Container>
  );
};
export default HistoryActivity;
